import { render, staticRenderFns } from "./A11.vue?vue&type=template&id=3673fb32&"
import script from "./A11.vue?vue&type=script&lang=ts&"
export * from "./A11.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports